module.exports = __webpack_public_path__ + "static/monolith-53e1c2c4fd7cdda83877dc77e42138e1.png";